import { makeStyles, withStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';

const useStyles = makeStyles((theme) => {
  return {
    textRight: {
      textAlign: 'right',
    },

    mt5: {
      marginTop: 5,
    },

    typography: {
      p: {
        fontSize: '12px',
      },
    },

    fontSizeSmall: {
      fontSize: '11px',
      fontWeight: 500,
      marginRight: '2px',
    },

    menuItem: {
      fontSize: '14px',
    },

    rootList: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-around',
      overflow: 'hidden',
      backgroundColor: theme.palette.background.paper,
    },
    gridList: {
      width: '100%',
    },

    imagesEvent: {
      '& .MuiIconButton-root': {
        display: 'none',
      },
      '& .Mui-checked': {
        display: 'inline-flex',
      },
      '&:hover': {
        '& .MuiIconButton-root': {
          display: 'inline-flex',
        },
      },

      '& img': {
        border: theme.palette.images.uploadBorderSolid,
        top: 0,
        maxHeight: '100%',
        transform: 'none',
        maxWidth: '100%',
        height: '100%',
        width: '100%',
        left: 0,
        objectFit: 'contain',
      },
    },

    uploadImage: {
      border: theme.palette.images.uploadBorderDashed,
      maxWidth: '100%',
      background: theme.palette.images.uploadImage,
      cursor: 'pointer',
    },

    uploadText: {
      color: theme.palette.images.uploadText,
    },

    checkboxRoot: {
      position: 'absolute',
      left: 0,
      padding: '4px',
      color: theme.palette.images.checkbox,

      '& svg': {
        width: '15px',
      },
    },

    uploadFile: {
      width: '100%',
      height: '100%',
      textTransform: 'capitalize',
      background: theme.palette.images.uploadImage,
      border: theme.palette.images.uploadBorderDashed,
    },

    profileImage: {
      position: 'absolute',
      fontSize: '8px',
      width: 'auto',
      textAlign: 'center',
      color: '#fff',
      background: theme.palette.primary.main,
      top: 0,
      right: 0,
      padding: '2px 6px',
      fontWeight: 500,
    },
  };
});

const WhiteBackgroundCheckbox = withStyles((theme) => ({
  root: {
    position: 'absolute',
    left: 0,
    padding: '4px',
    color: theme.palette.images.checkbox,

    '& .MuiIconButton-label': {
      position: 'relative',
      zIndex: 0,
    },
    '& .MuiSvgIcon-fontSizeSmall': {
      width: '17px',
    },
    '& .MuiIconButton-label:after': {
      content: '""',
      left: 3,
      top: 4,
      height: 12,
      width: 12,
      position: 'absolute',
      backgroundColor: 'white',
      zIndex: -1,
    },
  },
  checked: {
    color: `${theme.palette.primary.main} !important`,
  },
}))(Checkbox);

export { useStyles, WhiteBackgroundCheckbox };
